/**
 * Load Stripe.js on demand (payment screens only).
 * Keeping it out of index.html avoids m.stripe.network Radar scripts on every
 * page load — Safari + content blockers often surface those as a nosniff MIME
 * error and can leave the console looking like the app itself failed.
 */
var pending = null

export function loadStripeJs () {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Stripe.js requires a browser'))
  }
  if (typeof window.Stripe !== 'undefined') {
    return Promise.resolve(window.Stripe)
  }
  if (pending) return pending

  pending = new Promise(function (resolve, reject) {
    var script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/'
    script.async = true
    script.onload = function () {
      if (typeof window.Stripe === 'undefined') {
        pending = null
        reject(new Error('Stripe.js loaded but window.Stripe is missing'))
        return
      }
      resolve(window.Stripe)
    }
    script.onerror = function () {
      pending = null
      reject(new Error('Failed to load Stripe.js'))
    }
    document.head.appendChild(script)
  })

  return pending
}
